import { useContext, useMemo } from 'react';
import { CatalogDispatchContext, UxContext, CartContext } from '../store/CatalogContext';

export default function ViewCartBtn({ isFloating = false }: { isFloating?: boolean }) {
  const catalogDispatch = useContext(CatalogDispatchContext);
  const ux = useContext(UxContext);
  const cart = useContext(CartContext);

  // console.log('ViewCartBtn', catalogState);

  const handleViewCart = () => {
    catalogDispatch({
      type: 'UX',
      payload: {
        showCartWidget: true,
      },
    });
  };

  if (ux.showCartWidget && isFloating) {
    return null;
  }

  const itemCount = useMemo(() => {
    const itemCount = cart?.cartProducts?.reduce((acc, item) => {
      if (item.upSellProducts) {
        const upsellTotal = item.upSellProducts.reduce(
          (acc2, upsell) => (upsell.isSelected ? acc2 + upsell.quantity : acc2),
          0
        );
        return acc + item.quantity + upsellTotal;
      }
      return acc + item.quantity;
    }, 0);

    return itemCount;
  }, [cart?.cartProducts]);

  return (
    <button
      className={`${
        isFloating
          ? 'floating-view-cart-btn d-inline-flex d-md-none fixed-top'
          : 'view-cart-btn d-none d-md-inline-flex rounded py-1 px-2'
      } fw-600`}
      type="button"
      onClick={handleViewCart}
    >
      {isFloating ? <span className="visually-hidden">View Cart</span> : 'View Cart'}
      <span className="fw-400 position-absolute top-0 start-100 translate-middle badge rounded-pill">
        {itemCount && itemCount > 99 ? '99+' : itemCount ? itemCount : 0}
        <span className="visually-hidden" aria-hidden="true">
          items in your cart
        </span>
      </span>
    </button>
  );
}
